module.exports = __webpack_public_path__ + "media/images/logos/lowrance-cta-42c645eec2f9f5904f4da5930ad3ffd9.jpg";